module.exports = __webpack_public_path__ + "static/media/twitter.219822fb.svg";